"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _customerInfo = _interopRequireDefault(require("@/components/customerInfo"));

var _marketing = require("@/api/marketing");

var _validate = require("@/utils/validate");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: "addClerk",
  components: {
    customerInfo: _customerInfo.default
  },
  // props: {
  //   storeSelectList: Array
  // },
  data: function data() {
    return {
      pickerOptions: {
        disabledDate: function disabledDate(time) {// return time.getTime() < new Date().setTime(new Date().getTime() - 3600 * 1000 * 24); //不限制未来时间
          // return time.getTime() < Date.now() - 8.64e7 || time.getTime() > Date.now() + 600 * 8.64e7; //限制未来时间
        }
      },
      loading: false,
      dialogFormVisible: false,
      id: 0,
      ruleForm: {
        id: null,
        startTime: null,
        endTime: null,
        termTime: []
      },
      termTime: [],
      name: '',
      rules: {
        termTime: [{
          required: true,
          message: '请填写活动开始时间',
          trigger: 'change'
        }] // activityEndtime: [
        //   { required: true, message: '请填写活动结束时间', trigger: 'change' }
        // ]

      },
      obj: {
        address: "",
        applyno: "",
        begindate: "",
        chkcount: "",
        company: "",
        enddate: "",
        qty: "",
        qyname: "",
        subamt: "",
        tel: "",
        useamt: ""
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    add: function add(e) {
      console.log("？", e);
    },
    //营业时间
    onchangeTime: function onchangeTime(e) {
      console.log("选中", e); // this.termTime=[e[0],e[1]];

      this.ApplyInfoApi();
    },
    ApplyInfoApi: function ApplyInfoApi() {
      var _this = this;

      if (!this.termTime) {
        this.$message.info("请填写查询时间");
        return;
      }

      this.ruleForm.startTime = this.termTime[0].substring(0, 10);
      this.ruleForm.endTime = this.termTime[1].substring(0, 10);
      (0, _marketing.ApplyInfoApi)(this.ruleForm).then(function (res) {
        console.log(res);
        _this.obj = res;
      });
    },
    DoApplyApi: function DoApplyApi() {
      var _this2 = this;

      (0, _marketing.DoApplyApi)({
        applyno: this.obj.applyno
      }).then(function (res) {
        _this2.$message.success('提交成功');

        _this2.dialogFormVisible = false;

        _this2.$emit("tableList");

        _this2.clearFrom();
      });
    },
    //取消
    cancel: function cancel() {
      this.dialogFormVisible = false;
      this.clearFrom();
      this.resetForm('ruleForm');
      this.id = 0;
    },
    clearFrom: function clearFrom() {
      this.obj = {};
      this.ruleForm.termTime = [];
    },
    //重置
    resetForm: function resetForm(name) {
      this.$refs[name].resetFields();
    }
  }
};
exports.default = _default;